import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import getRecipientDisplayName from "@app/util/email/getRecipientDisplayName";

import EmailBody from "./EmailBody";
import styles from "./EmailView.module.scss";

interface EmailViewProps {
  body: string;
  className?: string;
  recipient?: EntitiesSupportedByEmailFeature;
  subject: string;
}

const EmailView: React.FC<EmailViewProps> = ({ body, className, recipient, subject }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      {recipient && (
        <div className={styles.label}>
          {intl.formatMessage(
            {
              id: "email.view.recipientLabel",
              defaultMessage: "To: {recipient}",
              description: "Manage email templates modal - recipient label",
            },
            {
              recipient: getRecipientDisplayName(recipient),
            }
          )}
        </div>
      )}
      <div className={styles.label}>
        {intl.formatMessage(
          {
            id: "email.view.subjectLabel",
            defaultMessage: "Subject: {subject}",
            description: "Manage email templates modal - subject label",
          },
          {
            subject,
          }
        )}
      </div>
      <EmailBody body={body} className={styles.body} />
    </div>
  );
};

export default EmailView;
